import { InjectionToken } from '@angular/core';
import { environment } from '../../../environments/environment';

export interface LoginPathConfig {
  loginPath: string;
}

export const loginPathConfig: LoginPathConfig = {
  loginPath: environment.loginPath,
};

export const LOGIN_PATH_CONFIG = new InjectionToken<LoginPathConfig>('loginPathConfig');
